var render = function render(){var _vm=this,_c=_vm._self._c;return _c('geko-base-crud',{attrs:{"config":_vm.config},scopedSlots:_vm._u([{key:"list-created_by",fn:function({ item }){return [_vm._v(" "+_vm._s(item.created_by)+" ")]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }